module.exports = require("@wildboar/x500/src/lib/modules/AuthenticationFramework/CertificationPath.ta");